import { GetYesterday } from "@/tools/time";

const searchConfig = (searchOptions) => {
  return {
    formItems: [
      {
        type: "date-picker-day",
        prop: "date_start",
        label: "起始日期",
        placeholder: "请选择起始日期",
        initialValue: GetYesterday(),
      },
      {
        type: "date-picker-day",
        prop: "date_end",
        label: "结束日期",
        placeholder: "请选择结束日期",
        initialValue: GetYesterday(),
      },
      // {
      //   type: "input",
      //   prop: "store_name ",
      //   label: "门店名称",
      //   placeholder: "请输入门店名称",
      // },
      // {
      //   type: "input",
      //   label: "终端ID",
      //   prop: "device_id",
      //   placeholder: "请输入终端ID",
      // },
      {
        type: "select",
        label: "支付方式",
        prop: "payment_method_id",
        options: searchOptions.payTypeList,
      },
      {
        type: "fetchSelect",
        label: "门店名称",
        prop: "store_id",
        options: searchOptions.storeList,
        // 添加change事件：当门店选择变化时触发
        change: (selectedValue) => {
          // selectedValue 是选择的门店id（因为storeList的value是store.id）
          searchOptions.handleStoreChange(selectedValue);
        }
      },
      {
        type: "fetchSelect",
        label: "终端名称",
        prop: "device_id",
        placeholder: "请先选择门店",
        options: searchOptions.terminalList,
      },
      // {
      //   type: "select",
      //   label: "结算通道",
      //   prop: "payment_channel_id",
      //   options: searchOptions.channelList,
      // },
    ],
  };
};

export default searchConfig;
